export const ON_SITE_TABLE_TITLE = 'US On-Site Segments';

export enum OnSiteSegment {
    Healthcare = 'Healthcare',
    Education = 'Education',
    Recreation = 'Recreation',
    RetailFood = 'Retail Food',
    Lodging = 'Lodging',
}

export const ON_SITE_SEGMENT_ORDER: OnSiteSegment[] = [
    OnSiteSegment.Healthcare,
    OnSiteSegment.Education,
    OnSiteSegment.Recreation,
    OnSiteSegment.RetailFood,
    OnSiteSegment.Lodging,
];

export const ON_SITE_LEFT_COLUMN_COUNT = 3;
